import { render } from "./uiGridItemColContent.vue?vue&type=template&id=99634d70&scoped=true"
import script from "./uiGridItemColContent.vue?vue&type=script&lang=js"
export * from "./uiGridItemColContent.vue?vue&type=script&lang=js"

import "./uiGridItemColContent.vue?vue&type=style&index=0&id=99634d70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99634d70"]])

export default __exports__